export const SEDAN = {
    TYPE: 'sedan',
    CODES: ['SD'],
};
export const COUPE = {
    TYPE: 'coupe',
    CODES: ['CP'],
};
export const HATCHBACK = {
    TYPE: 'hatchback',
    CODES: ['HB'],
};
export const VAN = {
    TYPE: 'van',
    CODES: ['WG', 'MV'],
};
export const CONVERTIBLE = {
    TYPE: 'convertible',
    CODES: ['CT'],
};
export const SUV = {
    TYPE: 'suv',
    CODES: ['SV', 'CO'],
};
export const PICKUP = {
    TYPE: 'pickup',
    CODES: ['PK', 'HP', 'CC'],
};
export const COMMERCIAL = {
    TYPE: 'commercial',
    CODES: ['CV', 'OT'],
};
export const PASSENGERVAN = {
    TYPE: 'passengervan',
    CODES: ['PV'],
};
export const CREWVAN = {
    TYPE: 'crewvan',
    CODES: ['WV'],
};
